class User {
  private tenantId = 'tenantId';
  private store: any = window.localStorage;
  setTenantId(tenantId: any) {
    this.store && this.store.setItem(this.tenantId, tenantId);
  }
  removeTenantId() {
    this.store && this.store.removeItem(this.tenantId);
  }
  getTenantId() {
    return this.store && this.store.getItem(this.tenantId);
  }
}
export default new User();
